import React from 'react';
import moment from 'moment';

import { strings } from 'APP_ROOT/localization';
import LambdaUtil from 'APP_ROOT/components/aws/lambda/lambdaUtil';
import Events from 'APP_ROOT/components/common/events';

const LOADING_ICON = '/images/raven-v-white.png';

export default class InvoicesList extends React.Component {

    constructor(props) {

        super(props);

        var fromDate = new Date();
        fromDate = new Date(fromDate.setMonth(fromDate.getMonth() - 1));
        var toDate = new Date();
        this.state = {
            errorMessage: null,
            loading: false,
            fromDate: fromDate,
            toDate: toDate,
            datesValid: true
        };
    }

    componentDidMount() {

        this.getInvoices();
    }

    getInvoices = (e) => {

        if (this.state.loading) return;
        this.setState({
            loading: true
        })
        //dates should be in date obj format or something moment.js can handle.
        // LambdaUtil.listInvoices(this.props.user.stage, this.state.fromDate, this.state.toDate, this.onListInvoicesSuccess, this.onListInvoicesFail);
        var fromDate = new Date()
        fromDate = new Date(fromDate.setFullYear(fromDate.getFullYear() - 100))
        var toDate = new Date() //today
        LambdaUtil.listInvoices(this.props.user.stage, fromDate, toDate, this.onListInvoicesSuccess, this.onListInvoicesFail);
    }

    onListInvoicesSuccess = (response) => {

        try {
            // console.log("LIST INVOICES", response);
            response = JSON.parse(response.Payload);
            // response = response.Payload
            if (response.status !== "ERROR") {

                var invoices = response.payload;
                //mark invoices with an index if they have another invoice on the same day.
                for (var i = 0; i < invoices.length; i++) {
                    //start at the second object and check if date is the same as last.
                    //then check if the last has duplicateIndex, if yes set duplicateIndex of current to +1 that of last.
                    //continue to next.
                    //this assumes the list is sorted so duplicates appear next to each other, 
                    if (invoices[i - 1]) {
                        if (invoices[i].invoiceDate === invoices[i - 1].invoiceDate) {
                            invoices[i].duplicateIndex = invoices[i - 1].duplicateIndex + 1;
                        } else {
                            //first item in series
                            invoices[i].duplicateIndex = 1;
                        }
                    } else {
                        //first item in series
                        invoices[i].duplicateIndex = 1;
                    }
                }
                this.setState({
                    invoices: invoices,
                    loading: false
                })
                document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
            } else throw new Error(response);
        } catch (e) {
            this.onListInvoicesFail(response);
        }
    }

    onListInvoicesFail = (response) => {

        console.error("LIST INVOICES FAIL", response);
        this.setState({
            errorMessage: "Failed to get invoices from the server.",
            loading: false
        })
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    downloadInvoice = (e, invoice) => {

        e.preventDefault();
        if (!invoice.status) {
            console.log('Download invoice number: ', invoice.invoiceNumber);
            var invoices = this.state.invoices;
            invoices.find(iv => {
                if (iv.invoiceNumber === invoice.invoiceNumber) iv.status = "DOWNLOADING"
            })
            this.setState({
                invoices: invoices
            });
            LambdaUtil.downladInvoice(this.props.user.stage, invoice.invoiceNumber, (response) => this.onDownloadInvoiceSuccess(response, invoice), (response) => this.onDownloadInvoiceFail(response, invoice));
        }
    }

    onDownloadInvoiceSuccess = (data, invoice) => {

        // console.log(data);
        var payload = JSON.parse(data.Payload);
        if (payload.status === 'ERROR')
            this.onDownloadInvoiceFail(data, invoice);

        if (payload.status === 'SUCCESS' && payload.payload && payload.payload.indexOf('http') > -1) {
            window.open(payload.payload, '_blank');
        }

        var invoices = this.state.invoices;
        invoices.find(iv => {
            if (iv.invoiceNumber === invoice.invoiceNumber) iv.status = "SUCCESS"
        })

        this.setState({
            downloadInvoiceError: null,
            downloadingInvoice: null,
            invoices: invoices
        });
    }

    onDownloadInvoiceFail = (err, invoice) => {

        console.error(err);

        var invoices = this.state.invoices;
        invoices.find(iv => {
            if (iv.invoiceNumber === invoice.invoiceNumber) iv.status = "FAIL"
        })

        this.setState({
            downloadInvoiceError: true,
            downloadingInvoice: null,
            invoices: invoices
        });
    }

    onFromDateFocus = (e) => {

        if (this.state.fromCalendarOpen) {
            this.setState({
                fromCalendarOpen: false
            })
        } else {
            this.setState({
                fromCalendarOpen: true
            }, () => {
                document.body.scrollTo({
                    top: window.pageYOffset,
                    behavior: 'smooth'
                })
            })
        }
    }

    onFromDateSelect = (fromDate) => {

        this.setState({
            fromDate: fromDate ? fromDate : this.state.fromDate,
            fromCalendarOpen: false
        }, () => {
            this.validateDates();
        })
    }

    onToDateFocus = (e) => {

        if (this.state.toCalendarOpen) {
            this.setState({
                toCalendarOpen: false
            })
        } else {
            this.setState({
                toCalendarOpen: true
            }, () => {
                document.body.scrollTo({
                    top: window.pageYOffset,
                    behavior: 'smooth'
                })
            })
        }
    }

    onToDateSelect = (toDate) => {

        this.setState({
            toDate: toDate ? toDate : this.state.toDate,
            toCalendarOpen: false
        }, () => {
            this.validateDates();
        })
    }

    validateDates() {

        var datesValid = false;
        var timeDiff = this.state.toDate.getTime() - this.state.fromDate.getTime();
        if (timeDiff > 0) {
            datesValid = true;
        }

        this.setState({
            datesValid: datesValid
        })
    }

    render() {

        try {
            // console.log("RENDER INVOICES", this.props, this.state);

            var message = null;
            if (this.state.loading) {
                message = <p><img className="loading-icon" src={LOADING_ICON} />{strings.account_invoices_loading_history_title}</p>
            }

            if (this.state.invoices && this.state.invoices.length < 1) {
                message = <p><i className="material-icons">warning</i>{strings.account_invoices_none_found}</p>;
            } else if (this.state.invoices) {
                message = <p>{strings.account_invoices_payments_history_description}</p>;
            }

            if (this.state.errorMessage) {
                message = <p><i className="material-icons">warning</i>{this.state.errorMessage}</p>
            }

            return (
                <div className="col-12 invoice-section">
                    <h3><i className="material-icons">assignment</i>{strings.account_invoices_payments_history_title}</h3>

                    {message}

                    {this.renderInvoiceSection()}
                </div>
            );
        } catch (e) {
            console.error(e);
            return null
        }
    }

    renderInvoiceSection() {

        if (!this.state.invoices) return null;

        var invoiceList = this.state.invoices.map((invoice, num) => {

            var title = "Payment on " + moment(invoice.invoiceDate).format("LL");
            if (invoice.duplicateIndex && invoice.duplicateIndex > 1) title += ' (' + invoice.duplicateIndex + ')';

            return (
                <li key={num}>
                    <button onClick={(e) => this.downloadInvoice(e, invoice)} disabled={invoice.status/*disable if any status is set (DOWNLOADING||SUCCESS||FAIL)*/}>
                        {invoice.status === "SUCCESS" ?
                            <span><i className="material-icons blue">check</i>{title}</span>
                            : invoice.status === "DOWNLOADING" ?
                                <span><img className="loading-icon" src={LOADING_ICON} />{title}</span> :
                                <span><i className="material-icons">file_download</i>{title}</span>}
                    </button>
                    {invoice.status === "FAIL" ?
                        <p>{strings.account_invoices_download_failed_message}</p> :
                        null
                    }
                </li>
            )
        })

        return (
            <div>
                <div className="row">
                    <div className="col-12 content-group">
                        <ul className="styled-list">
                            {invoiceList}
                        </ul>
                    </div>
                </div>

                <div className="button-row">
                    <div>{this.state.downloadInvoiceError ? (<p className="error-message"><i className="material-icons">error_outline</i><span>{strings.formatString(strings.account_error_invoice_download)}</span></p>) : null}</div>
                </div>
            </div>
        );
    }
}
